import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type StripeContext = 'organizations' | 'pmcs';

export interface BillingEvent {
    context: StripeContext;
    id: number;
}

@Injectable({ providedIn: 'root' })
export class BillingEventsService {
    // Emitted after successful mutations
    readonly subscriptionChanged$ = new Subject<BillingEvent>();
    readonly invoiceChanged$ = new Subject<BillingEvent>();
    readonly balanceChanged$ = new Subject<BillingEvent>();
    readonly paymentMethodChanged$ = new Subject<BillingEvent>();
}
